// import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
// import axios from 'axios';
// import { debounce } from 'lodash';
// import './Search.css';
// import { API_URL } from '../services/api';

// const Search = forwardRef(({
//   setProducts,
//   setTotalProducts,
//   setIsLoading,
//   setNextPageUrl,
//   setPrevPageUrl
// }, ref) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [placeholder, setPlaceholder] = useState('Eg) banana leaf');
//   const [selectedFilter, setSelectedFilter] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [error, setError] = useState(null);

//   // Expose search state to parent component
//   useImperativeHandle(ref, () => ({
//     searchTerm,
//     selectedFilter,
//     selectedCategory
//   }));

//   // Placeholders array remains the same
//   const placeholderOptions = [
//     'T-shirt', 'Face Cream', 'Natural Deodorant', 'Coconut Bowl',
//     'Reusable Straw', 'Organic Soap', 'Zero-Waste Toothpaste'
//   ];

//   // Filters and categories remain the same
//   const filters = [
//     { label: "All Products", value: "" },
//     { label: "Eco-New", value: "eco-new" },
//     { label: "Secondhand", value: "secondhand" },
//     { label: "Price: Low to High", value: "price_low_to_high" },
//     { label: "Price: High to Low", value: "price_high_to_low" },
//   ];

//   const categories = [
//     { label: "All Categories", value: "" },
//     { label: "Apparel", value: "Apparel" },
//     { label: "Shoes", value: "Shoes" },
//     { label: "Accessories", value: "Accessories" },
//     { label: "Home", value: "Home Goods" },
//     { label: "Cosmetics", value: "Cosmetics / Skin Care" },
//     { label: "Hygiene", value: "Hygiene" },
//     { label: "Cleaning", value: "Cleaning Products" },
//     { label: "Stationery", value: "Stationary" },
//     { label: "Art Supplies", value: "Art Supplies" },
//   ];

//   // Create a debounced search function
//   const debouncedSearch = useCallback(
//     debounce(async (search, filter, category) => {
//       try {
//         setIsLoading(true);
//         setError(null);

//         const response = await axios.get(`${API_URL}api/search/`, {
//           params: {
//             search,
//             filter,
//             category,
//             page: 1,  // Reset to first page
//             page_size: 20
//           },
//           // Set timeout to handle slow responses
//           timeout: 55000
//         });

//         setProducts(response.data.results || []);
//         setTotalProducts(response.data.count || 0);

//         // Set pagination URLs to be used by parent component
//         if (setNextPageUrl) setNextPageUrl(response.data.next);
//         if (setPrevPageUrl) setPrevPageUrl(response.data.previous);
//       } catch (err) {
//         console.error('Search error:', err);
//         setError('Search request timed out. Please try again or refine your search criteria.');
//         // Keep showing previous results instead of clearing them
//       } finally {
//         setIsLoading(false);
//       }
//     }, 500), // 500ms debounce delay
//     [setProducts, setTotalProducts, setIsLoading, setNextPageUrl, setPrevPageUrl] // Dependencies
//   );

//   // Effect for changing placeholder
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const random = Math.floor(Math.random() * placeholderOptions.length);
//       setPlaceholder(`Eg) ${placeholderOptions[random]}`);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   // Effect to trigger search when filters change
//   useEffect(() => {
//     debouncedSearch(searchTerm, selectedFilter, selectedCategory);
//   }, [searchTerm, selectedFilter, selectedCategory, debouncedSearch]);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     // Immediately trigger the search (cancel debounce)
//     debouncedSearch.flush();
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//     // The effect will trigger the search
//   };

//   const handleFilterChange = (e) => {
//     setSelectedFilter(e.target.value);
//     // The effect will trigger the search
//   };

//   const handleClearAll = () => {
//     setSearchTerm('');
//     setSelectedFilter('');
//     setSelectedCategory('');
//     // The effect will trigger the search with empty values
//   };

//   return (
//     <>
//       <div className="search-component">
//         <form onSubmit={handleSearch}>
//           <div className="search-bar">
//             <div className="search-category-wrapper">
//               <select
//                 value={selectedCategory}
//                 onChange={handleCategoryChange}
//                 className="category-dropdown"
//                 aria-label="Select category"
//               >
//                 {categories.map((category) => (
//                   <option key={category.value} value={category.value}>
//                     {category.label}
//                   </option>
//                 ))}
//               </select>
//               <span className="divider"></span>
//             </div>
//             <input
//               type="text"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               placeholder={placeholder}
//               className="search-input"
//               aria-label="Search products"
//             />
//             <button type="submit" className="search-button" aria-label="Search">
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
//                   stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//               </svg>
//             </button>
//           </div>

//           <div className="filters-row">
//             <div className="filter-group">
//               <select
//                 id="filter-dropdown"
//                 value={selectedFilter}
//                 onChange={handleFilterChange}
//                 className="filter-dropdown"
//               >
//                 {filters.map((filter) => (
//                   <option key={filter.value} value={filter.value}>
//                     {filter.label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <button
//               type="button"
//               className="clear-button"
//               onClick={handleClearAll}
//               disabled={!searchTerm && !selectedFilter && !selectedCategory}
//             >
//               Clear All
//             </button>
//           </div>

//           {error && <p className="error-message" role="alert">{error}</p>}
//         </form>
//       </div>
//     </>
//   );
// });

// export default Search;

// import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
// import axios from 'axios';
// import { debounce } from 'lodash';
// import './Search.css';
// import { API_URL } from '../services/api';

// // Cache key for filters
// const FILTER_CACHE_KEY = 'shop_filters_cache';

// const Search = forwardRef(({
//   setProducts,
//   setTotalProducts,
//   setIsLoading,
//   setNextPageUrl,
//   setPrevPageUrl,
//   hasMatchingCache = false // New prop to indicate if Shop has matching cached data
// }, ref) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [placeholder, setPlaceholder] = useState('Eg) banana leaf');
//   const [selectedFilter, setSelectedFilter] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [error, setError] = useState(null);
//   const [isInitialized, setIsInitialized] = useState(false);

//   // Expose search state to parent component
//   useImperativeHandle(ref, () => ({
//     searchTerm,
//     selectedFilter,
//     selectedCategory
//   }));

//   // Save filters to cache
//   const saveFiltersToCache = useCallback((search, filter, category) => {
//     try {
//       const filterData = {
//         searchTerm: search,
//         selectedFilter: filter,
//         selectedCategory: category,
//         timestamp: Date.now()
//       };
//       localStorage.setItem(FILTER_CACHE_KEY, JSON.stringify(filterData));
//     } catch (error) {
//       console.error('Error saving filters to cache:', error);
//     }
//   }, []);

//   // Load cached filters on component mount
//   useEffect(() => {
//     try {
//       const cachedFilters = localStorage.getItem(FILTER_CACHE_KEY);
//       if (cachedFilters) {
//         const { searchTerm: cachedSearch, selectedFilter: cachedFilter, selectedCategory: cachedCategory } = JSON.parse(cachedFilters);
//         setSearchTerm(cachedSearch || '');
//         setSelectedFilter(cachedFilter || '');
//         setSelectedCategory(cachedCategory || '');
//       }
//     } catch (error) {
//       console.error('Error loading cached filters:', error);
//     }
//     setIsInitialized(true);
//   }, []);

//   // Placeholders array
//   const placeholderOptions = [
//     'T-shirt', 'Face Cream', 'Natural Deodorant', 'Coconut Bowl',
//     'Reusable Straw', 'Organic Soap', 'Zero-Waste Toothpaste'
//   ];

//   // Filters and categories remain the same
//   const filters = [
//     { label: "All Products", value: "" },
//     { label: "Eco-New", value: "eco-new" },
//     { label: "Secondhand", value: "secondhand" },
//     { label: "Price: Low to High", value: "price_low_to_high" },
//     { label: "Price: High to Low", value: "price_high_to_low" },
//   ];

//   const categories = [
//     { label: "All Categories", value: "" },
//     { label: "Apparel", value: "Apparel" },
//     { label: "Shoes", value: "Shoes" },
//     { label: "Accessories", value: "Accessories" },
//     { label: "Home", value: "Home Goods" },
//     { label: "Cosmetics", value: "Cosmetics / Skin Care" },
//     { label: "Hygiene", value: "Hygiene" },
//     { label: "Cleaning", value: "Cleaning Products" },
//     { label: "Stationery", value: "Stationary" },
//     { label: "Art Supplies", value: "Art Supplies" },
//   ];

//   // Create a debounced search function - EXACTLY like your original
//   const debouncedSearch = useCallback(
//     debounce(async (search, filter, category) => {
//       try {
//         setIsLoading(true);
//         setError(null);

//         const response = await axios.get(`${API_URL}api/search/`, {
//           params: {
//             search,
//             filter,
//             category,
//             page: 1,  // Reset to first page
//             page_size: 20
//           },
//           timeout: 55000
//         });

//         setProducts(response.data.results || []);
//         setTotalProducts(response.data.count || 0);

//         // Set pagination URLs to be used by parent component
//         if (setNextPageUrl) setNextPageUrl(response.data.next);
//         if (setPrevPageUrl) setPrevPageUrl(response.data.previous);

//         // Save filters to cache after successful search
//         saveFiltersToCache(search, filter, category);
//       } catch (err) {
//         console.error('Search error:', err);
//         setError('Search request timed out. Please try again or refine your search criteria.');
//         // Keep showing previous results instead of clearing them
//       } finally {
//         setIsLoading(false);
//       }
//     }, 500), // 500ms debounce delay
//     [setProducts, setTotalProducts, setIsLoading, setNextPageUrl, setPrevPageUrl, saveFiltersToCache] // Dependencies
//   );

//   // Effect for changing placeholder
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const random = Math.floor(Math.random() * placeholderOptions.length);
//       setPlaceholder(`Eg) ${placeholderOptions[random]}`);
//     }, 3000);

//     return () => clearInterval(interval);
//   }, []);

//   // Effect to trigger search when filters change - only after initialization and if no matching cache
//   useEffect(() => {
//     if (isInitialized && !hasMatchingCache) {
//       debouncedSearch(searchTerm, selectedFilter, selectedCategory);
//     }
//   }, [searchTerm, selectedFilter, selectedCategory, debouncedSearch, isInitialized, hasMatchingCache]);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     // Immediately trigger the search (cancel debounce)
//     debouncedSearch.flush();
//   };

//   const handleCategoryChange = (e) => {
//     setSelectedCategory(e.target.value);
//     // The effect will trigger the search
//   };

//   const handleFilterChange = (e) => {
//     setSelectedFilter(e.target.value);
//     // The effect will trigger the search
//   };

//   const handleClearAll = () => {
//     setSearchTerm('');
//     setSelectedFilter('');
//     setSelectedCategory('');
//     // Clear cached filters
//     localStorage.removeItem(FILTER_CACHE_KEY);
//     // The effect will trigger the search with empty values
//   };

//   return (
//     <>
//       <div className="search-component">
//         <form onSubmit={handleSearch}>
//           <div className="search-bar">
//             <div className="search-category-wrapper">
//               <select
//                 value={selectedCategory}
//                 onChange={handleCategoryChange}
//                 className="category-dropdown"
//                 aria-label="Select category"
//               >
//                 {categories.map((category) => (
//                   <option key={category.value} value={category.value}>
//                     {category.label}
//                   </option>
//                 ))}
//               </select>
//               <span className="divider"></span>
//             </div>
//             <input
//               type="text"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               placeholder={placeholder}
//               className="search-input"
//               aria-label="Search products"
//             />
//             <button type="submit" className="search-button" aria-label="Search">
//               <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
//                   stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//               </svg>
//             </button>
//           </div>

//           <div className="filters-row">
//             <div className="filter-group">
//               <select
//                 id="filter-dropdown"
//                 value={selectedFilter}
//                 onChange={handleFilterChange}
//                 className="filter-dropdown"
//               >
//                 {filters.map((filter) => (
//                   <option key={filter.value} value={filter.value}>
//                     {filter.label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <button
//               type="button"
//               className="clear-button"
//               onClick={handleClearAll}
//               disabled={!searchTerm && !selectedFilter && !selectedCategory}
//             >
//               Clear All
//             </button>
//           </div>

//           {error && <p className="error-message" role="alert">{error}</p>}
//         </form>
//       </div>
//     </>
//   );
// });

// export default Search;

import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import { debounce } from "lodash";
import "./Search.css";
import { API_URL } from "../services/api";

// Cache key for filters
const FILTER_CACHE_KEY = "shop_filters_cache";

const Search = forwardRef(
  (
    {
      setProducts,
      setTotalProducts,
      setIsLoading,
      setNextPageUrl,
      setPrevPageUrl,
      currentPage, // Add currentPage prop
      setCurrentPage, // Add setCurrentPage prop
      hasMatchingCache = false, // New prop to indicate if Shop has matching cached data
    },
    ref
  ) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [placeholder, setPlaceholder] = useState("Eg) banana leaf");
    const [selectedFilter, setSelectedFilter] = useState("");
    // const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedCategory, setSelectedCategory] =
      useState("weekly_favorites");

    const [error, setError] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);

    // Expose search state to parent component
    useImperativeHandle(ref, () => ({
      searchTerm,
      selectedFilter,
      selectedCategory,
    }));

    // Save filters to cache (now includes page)
    const saveFiltersToCache = useCallback(
      (search, filter, category, page = 1) => {
        try {
          const filterData = {
            searchTerm: search,
            selectedFilter: filter,
            selectedCategory: category,
            currentPage: page,
            timestamp: Date.now(),
          };
          localStorage.setItem(FILTER_CACHE_KEY, JSON.stringify(filterData));
        } catch (error) {
          console.error("Error saving filters to cache:", error);
        }
      },
      []
    );

    // Load cached filters on component mount
    useEffect(() => {
      try {
        const cachedFilters = localStorage.getItem(FILTER_CACHE_KEY);
        if (cachedFilters) {
          const {
            searchTerm: cachedSearch,
            selectedFilter: cachedFilter,
            selectedCategory: cachedCategory,
            currentPage: cachedPage,
          } = JSON.parse(cachedFilters);

          setSearchTerm(cachedSearch || "");
          setSelectedFilter(cachedFilter || "");
          setSelectedCategory(cachedCategory || "");

          // Set the page in parent component if provided
          if (cachedPage && setCurrentPage) {
            setCurrentPage(cachedPage);
          }
        }
      } catch (error) {
        console.error("Error loading cached filters:", error);
      }
      setIsInitialized(true);
    }, [setCurrentPage]);

    // Placeholders array
    const placeholderOptions = [
      "T-shirt",
      "Face Cream",
      "Natural Deodorant",
      "Coconut Bowl",
      "Reusable Straw",
      "Organic Soap",
      "Zero-Waste Toothpaste",
    ];

    // Filters and categories remain the same
    const filters = [
      { label: "No Filter", value: "" },
      // { label: "Eco-New", value: "eco-new" },
      // { label: "Secondhand", value: "secondhand" },
      { label: "Price: Low to High", value: "price_low_to_high" },
      { label: "Price: High to Low", value: "price_high_to_low" },
    ];

    const categories = [
      { label: "Current Favorites", value: "weekly_favorites" },
      { label: "All Products", value: "" },
      { label: "Apparel", value: "Apparel" },
      { label: "Shoes", value: "Shoes" },
      { label: "Accessories", value: "Accessories" },
      { label: "Home", value: "Home Goods" },
      { label: "Cosmetics", value: "Cosmetics / Skin Care" },
      { label: "Hygiene", value: "Hygiene" },
      { label: "Cleaning", value: "Cleaning Products" },
      { label: "Stationery", value: "Stationary" },
      { label: "Art Supplies", value: "Art Supplies" },
    ];

    // Create a debounced search function - modified to use current page
    // OG
    const debouncedSearch = useCallback(
      debounce(async (search, filter, category, page = 1) => {
        try {
          const hasActiveSearch =
            search || filter || (category && category !== "weekly_favorites");
          if (hasActiveSearch) {
            setIsLoading(true);
          }
          // setIsLoading(true);
          setError(null);

          const response = await axios.get(`${API_URL}api/search/`, {
            params: {
              search,
              filter,
              category,
              page: page, // Use the provided page
              page_size: 20,
            },
            timeout: 55000,
          });

          setProducts(response.data.results || []);
          setTotalProducts(response.data.count || 0);

          // Set pagination URLs to be used by parent component
          if (setNextPageUrl) setNextPageUrl(response.data.next);
          if (setPrevPageUrl) setPrevPageUrl(response.data.previous);

          // Save filters to cache after successful search (include page)
          saveFiltersToCache(search, filter, category, page);
        } catch (err) {
          console.error("Search error:", err);
          setError(
            "Search request timed out. Please try again or refine your search criteria."
          );
          // Keep showing previous results instead of clearing them
        } finally {
          setIsLoading(false);
        }
      }, 500), // 500ms debounce delay
      [
        setProducts,
        setTotalProducts,
        setIsLoading,
        setNextPageUrl,
        setPrevPageUrl,
        saveFiltersToCache,
      ] // Dependencies
    );

    // Effect for changing placeholder
    useEffect(() => {
      const interval = setInterval(() => {
        const random = Math.floor(Math.random() * placeholderOptions.length);
        setPlaceholder(`Eg) ${placeholderOptions[random]}`);
      }, 3000);

      return () => clearInterval(interval);
    }, []);

    // Effect to trigger search when filters change - now uses currentPage from props
    useEffect(() => {
      if (isInitialized && !hasMatchingCache) {
        // Use currentPage from props, or default to 1
        const pageToUse = currentPage || 1;
        debouncedSearch(
          searchTerm,
          selectedFilter,
          selectedCategory,
          pageToUse
        );
      }
    }, [
      searchTerm,
      selectedFilter,
      selectedCategory,
      debouncedSearch,
      isInitialized,
      hasMatchingCache,
      currentPage,
    ]);

    // Replace this useEffect:
    // useEffect(() => {
    //   if (isInitialized && !hasMatchingCache && selectedCategory !== 'weekly_favorites') {
    //     const pageToUse = currentPage || 1;
    //     debouncedSearch(searchTerm, selectedFilter, selectedCategory, pageToUse);
    //   }
    // }, [searchTerm, selectedFilter, selectedCategory, debouncedSearch, isInitialized, hasMatchingCache, currentPage]);

    const handleSearch = (e) => {
      e.preventDefault();
      // Reset to page 1 for new searches
      if (setCurrentPage) {
        setCurrentPage(1);
      }
      // Trigger search with page 1
      debouncedSearch(searchTerm, selectedFilter, selectedCategory, 1);
    };

    const handleCategoryChange = (e) => {
      setSelectedCategory(e.target.value);
      // Reset to page 1 when changing category
      if (setCurrentPage) {
        setCurrentPage(1);
      }
      // The effect will trigger the search with page 1
    };

    const handleFilterChange = (e) => {
      setSelectedFilter(e.target.value);
      // Reset to page 1 when changing filter
      if (setCurrentPage) {
        setCurrentPage(1);
      }
      // The effect will trigger the search with page 1
    };

    const handleClearAll = () => {
      setSearchTerm("");
      setSelectedFilter("");
      setSelectedCategory("");
      // Reset to page 1
      if (setCurrentPage) {
        setCurrentPage(1);
      }
      // Clear cached filters
      localStorage.removeItem(FILTER_CACHE_KEY);
      // The effect will trigger the search with empty values and page 1
    };

    return (
      <>
        <div className="search-component">
          <form onSubmit={handleSearch}>
            <div className="search-bar">
              <div className="search-category-wrapper">
                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  className="category-dropdown"
                  aria-label="Select category"
                >
                  {categories.map((category) => (
                    <option key={category.value} value={category.value}>
                      {category.label}
                    </option>
                  ))}
                </select>
                <span className="divider"></span>
              </div>
              {/* <div id="search-category-input"> */}
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder={placeholder}
                className="search-input"
                aria-label="Search products"
              />
              {/* </div> */}
              <button
                type="submit"
                className="search-button"
                aria-label="Search"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="filters-row">
              <div className="filter-group">
                <select
                  id="filter-dropdown"
                  value={selectedFilter}
                  onChange={handleFilterChange}
                  className="filter-dropdown"
                >
                  {filters.map((filter) => (
                    <option key={filter.value} value={filter.value}>
                      {filter.label}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="button"
                className="clear-button"
                onClick={handleClearAll}
                disabled={!searchTerm && !selectedFilter && !selectedCategory}
              >
                Clear All
              </button>
            </div>

            {error && (
              <p className="error-message" role="alert">
                {error}
              </p>
            )}
          </form>
        </div>
      </>
    );
  }
);

export default Search;
